<div class="content-wrapper">
    <div class="content-body">
        <app-content-header [contentHeader]="contentHeader"></app-content-header>

        <section class="invoice-preview-wrapper">

            <div class="row invoice-preview">
                <!-- Invoice -->
                <div class="col-xl-9 col-md-8 col-12 printRef">
                    <div class="card invoice-preview-card">
                        <div class="card-body invoice-padding pb-0">
                            <!-- Header Starts -->
                            <div
                                class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0 align-items-start">
                                <div style="display: flex; align-items: center; width: 100%;">
                                    <!-- Image container -->
                                    <div style="width: 100px; height: 100px; border: 2px solid #ddd; display: flex; justify-content: center; align-items: center; background-color: #333; color: white; margin-right: 20px;">
                                        <img [src]="getBase64ImageUrl(company.companyFile64)" alt="Logo Yok" *ngIf="company.companyFile64" width="100" height="100">
                                    </div>
                                
                                    <!-- Input container -->
                                    <div style="width: 50%; display: flex; flex-direction: column;">
                                        <label for="basicInput" style="font-weight: 600; display: block;">Başlık</label>
                                        <input type="text" class="form-control" id="basicInput" placeholder="Başlık Giriniz" [(ngModel)]="title" />
                                    </div>
                                </div>
                                
                                <div style="width: 130px;">
                                    <div
                                        style="width: 100px; height: 100px; border: 2px solid #ddd;align-items: center; background-color: #333; color: white;">
                                        <div>
                                            <p *ngIf="pdf.files?.length < 1">Logo</p>
                                            <img [src]="getBase64ImageUrl(pdf.files[0].base64Image)" alt="resim yok"
                                                width="100" height="100" *ngIf="pdf.files?.length > 0">
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <input type="file" accept=".png, .jpeg, .jpg" id="customFile"
                                            (change)="onFileSelected($event)" class="custom-file-input" />
                                        <label class="custom-file-label" for="customFile">{{ fileName }}</label>
                                    </div>
                                </div>
                            </div>
                            <div
                                style="max-width: 500px; display: flex; flex-direction: column; justify-content: center;">
                                <!-- align-items-center ekledik -->
                                <label for="quill-editor" style="font-weight: 600; display: block;">Üst Başlık
                                    Açıklama:</label>
                                <textarea class="form-control" id="basicTextarea" rows="2"
                                    [(ngModel)]="titleDescription" placeholder="Başlık Açıklama"></textarea>
                            </div>
                            <!-- Header Ends -->
                        </div>


                        <hr class="invoice-spacing" />

                        <div style="margin: 2rem;">
                            <span class="font-weight-bold">Açıklama: </span>
                            <textarea class="form-control" id="basicTextarea" rows="3" [(ngModel)]="description"
                                placeholder="Açıklama"></textarea>

                        </div>

                        <hr class="invoice-spacing" />

                        <!-- Address And Contact Starts -->
                        <div class="card-body invoice-padding pt-0">
                            <div class="row invoice-spacing">
                                <div class="col-xl-8 p-0">
                                    <h6 class="mb-2">Teklif Verilen Müşteri:</h6>
                                    <h6 class="mb-25">Deneme</h6>
                                    <p class="card-text mb-25">deneme adres no:1 d:20</p>
                                    <p class="card-text mb-25">5124414241</p>
                                    <p class="card-text mb-0">fsafa@gmail.com</p>
                                </div>
                                <div class="col-xl-4 p-0 mt-xl-0 mt-2">
                                    <h6 class="mb-2">Payment Details:</h6>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td class="pr-1">Tarih:</td>
                                                <td>
                                                    <span class="font-weight-bold">22.05.2024</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="pr-1">Teklif No:</td>
                                                <td>2024-0001</td>
                                            </tr>
                                            <tr>
                                                <td class="pr-1">Vade Gün:</td>
                                                <td>30</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <!-- Address And Contact Ends -->

                        <!-- Invoice Description Starts -->
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th class="py-1">Örnek Table</th>
                                        <th class="py-1">Fiyat</th>
                                        <th class="py-1">Adet</th>
                                        <th class="py-1">Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="py-1">
                                            <p class="card-text font-weight-bold mb-25">Native App Development</p>

                                        </td>
                                        <td class="py-1">
                                            <span class="font-weight-bold">$60.00</span>
                                        </td>
                                        <td class="py-1">
                                            <span class="font-weight-bold">30</span>
                                        </td>
                                        <td class="py-1">
                                            <span class="font-weight-bold">$1,800.00</span>
                                        </td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <td class="py-1">
                                            <p class="card-text font-weight-bold mb-25">Ui Kit Design</p>

                                        </td>
                                        <td class="py-1">
                                            <span class="font-weight-bold">$60.00</span>
                                        </td>
                                        <td class="py-1">
                                            <span class="font-weight-bold">20</span>
                                        </td>
                                        <td class="py-1">
                                            <span class="font-weight-bold">$1200.00</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="card-body invoice-padding pb-0">
                            <div class="row invoice-sales-total-wrapper">
                                <div class="col-md-6 order-md-1 order-2 mt-md-0 mt-3">
                                    <p class="card-text mb-0">
                                        <span class="font-weight-bold">Salesperson:</span> <span class="ml-75">Alfie
                                            Solomons</span>
                                    </p>
                                </div>
                                <div class="col-md-6 d-flex justify-content-end order-md-2 order-1">
                                    <div class="invoice-total-wrapper">
                                        <div class="invoice-total-item">
                                            <p class="invoice-total-title">Subtotal:</p>
                                            <p class="invoice-total-amount">$1800</p>
                                        </div>
                                        <div class="invoice-total-item">
                                            <p class="invoice-total-title">Discount:</p>
                                            <p class="invoice-total-amount">$28</p>
                                        </div>
                                        <div class="invoice-total-item">
                                            <p class="invoice-total-title">Tax:</p>
                                            <p class="invoice-total-amount">21%</p>
                                        </div>
                                        <hr class="my-50" />
                                        <div class="invoice-total-item">
                                            <p class="invoice-total-title">Total:</p>
                                            <p class="invoice-total-amount">$1690</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Invoice Description Ends -->

                        <hr class="invoice-spacing" />

                        <!-- Invoice Note Starts -->
                        <div class="card-body invoice-padding pt-0">

                            <span class="font-weight-bold">Alt Başlık: </span>
                            <textarea class="form-control" id="basicTextarea" rows="3" [(ngModel)]="footerDesciption"
                                placeholder="Alt başlık açıklama"></textarea>
                        </div>
                        <!-- Invoice Note Ends -->
                    </div>
                </div>
                <!--/ Invoice -->

                <!-- Invoice Actions -->
                <div class="col-xl-3 col-md-4 col-12 invoice-actions mt-md-0 mt-2">
                    <div class="card">
                        <div class="card-body">
                            <input type="text" class="form-control mb-1" id="basicInput" placeholder="Pdf Başlığı gir"
                                [(ngModel)]="pdfTitle" />
                            <button class="btn btn-outline-secondary btn-block btn-download-invoice mb-75" rippleEffect
                                (click)="generatePDF()">
                                Önizleme
                            </button>
                            <button class="btn btn-success btn-block" data-toggle="modal" [disabled]="pdfTitle == null"
                                (click)="updatePdf()" data-target="#add-payment-sidebar" rippleEffect>
                                Güncelle
                            </button>
                        </div>
                    </div>
                </div>
                <!--/ Invoice Actions -->
            </div>
        </section>
    </div>
</div>